import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { LecturesWorkshopsRoutingModule } from './lectures-workshops-routing.module';
import { LecturesWorkshopsListComponent } from './lectures-workshops-list/lectures-workshops-list.component';
import { LecturesWorkshopsCreateComponent } from './lectures-workshops-create/lectures-workshops-create.component';

@NgModule({
  declarations: [LecturesWorkshopsListComponent, LecturesWorkshopsCreateComponent],
  imports: [
    CommonModule,
    LecturesWorkshopsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class LecturesWorkshopsModule { }
